export default {
  baseUrl: 'https://cloud.zeyos.com/bdsg/remotecall/bds.survey.api/survey',
  title: 'Mitgliederbefragung des Bund der Selbständigen',
  intro: () => import('./src/Intro.vue')
};
